import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function Signup() {
  const [nombre, setNombre] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí podrías guardar datos reales en backend.
    // Para ahora, simula login directo.
    login({ nombre, rol: "user" });
    navigate("/dashboard");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-quantus-navy px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm p-8 bg-white rounded-2xl shadow-quantus-lg border border-white/10"
      >
        <h2 className="mb-1 text-2xl font-display font-semibold text-blueGray-800">
          Crear cuenta
        </h2>
        <p className="mb-6 text-sm text-blueGray-400">Quantus Invoice · Sirius Solutions</p>
        <label className="block text-xs font-display font-semibold uppercase tracking-wide text-blueGray-600 mb-2">
          Nombre
        </label>
        <input
          type="text"
          placeholder="Nombre"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          className="w-full px-4 py-3 mb-5 rounded-lg border border-blueGray-200 text-blueGray-700 placeholder-blueGray-300 focus:outline-none focus:ring-2 focus:ring-quantus-blue-300 focus:border-quantus-blue-400 transition"
          required
        />
        <button
          type="submit"
          className="w-full text-white text-sm font-display font-semibold uppercase tracking-wide px-4 py-3 rounded-lg bg-quantus-blue-500 hover:bg-quantus-blue-600 shadow-quantus transition-colors"
        >
          Registrarse
        </button>
      </form>
    </div>
  );
}

export default Signup;
